module.exports = __webpack_public_path__ + "img/info-circle.597e0a37.svg";